<template>

    <form v-on:submit.prevent="">

        <BaseInputFloatinglabel type="text"
                   placeholder="Name"
                                icon="th"
                   v-model="form.name"/>

        <div class="action">
          <BaseButton v-if="type === 'create'"
                       :loading="creating"
                       :disabled="checkForm || creating"
                       icon="plus"
                       label="Erstellen"
                       :submit="true"
                       @click="create"/>
          <BaseButton v-if="hasManagerRole && type === 'edit'"
                       :loading="removing"
                       :disabled="removing"
                       icon="trash"
                       label="Löschen"
                       :remove="true"
                       @click="remove"/>
          <BaseButton v-if="type === 'edit'"
                       :loading="updating"
                       :disabled="checkForm || updating"
                       icon="save"
                       label="Speichern"
                       :submit="true"
                       @click="update"/>
        </div>

    </form>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  name: 'BusinessContactTopicForm',
  props: ['businessContactTopic', 'type'],
  data () {
    return {
      form: {},
      creating: false,
      updating: false,
      removing: false
    }
  },
  created () {
    this.form = cloneDeep(this.businessContactTopic)
  },
  methods: {
    async create () {
      try {
        this.creating = true
        const response = await this.createBusinessContactTopic({ data: this.form })
        this.$vfm.hide('business-contact-topic-create')
        this.$toasted.success('B2B Kontakt Schwerpunkt ' + response.data.name + ' erstellt', { icon: 'fas fa-th' })
        this.creating = false
        await this.getBusinessContactTopics()
      } catch (error) {
        this.creating = false
      }
    },
    async update () {
      try {
        this.updating = true
        const response = await this.updateBusinessContactTopic({ id: this.form.id, data: this.form })
        this.$vfm.hide('business-contact-topic-edit')
        this.$toasted.success('B2B Kontakt Schwerpunkt ' + response.data.name + ' gespeichert', { icon: 'fas fa-th' })
        this.updating = false
        await this.getBusinessContactTopic({ id: this.form.id })
      } catch (error) {
        this.updating = false
      }
    },
    async remove () {
      try {
        this.removing = true
        await this.deleteBusinessContactTopic({ id: this.form.id })
        this.$vfm.hide('business-contact-topic-edit')
        this.$toasted.success('B2B Kontakt Schwerpunkt gelöscht', { icon: 'fas fa-th' })
        this.removing = false
        await this.getBusinessContactTopics()
      } catch (error) {
        this.removing = false
      }
    },
    ...mapActions({
      createBusinessContactTopic: 'businessContactTopics/create',
      updateBusinessContactTopic: 'businessContactTopics/replace',
      deleteBusinessContactTopic: 'businessContactTopics/destroy',
      getBusinessContactTopic: 'businessContactTopics/fetchSingle',
      getBusinessContactTopics: 'businessContactTopics/fetchList'
    })
  },
  computed: {
    checkForm () {
      return !(this.form.name)
    },
    ...mapGetters({
      hasManagerRole: 'auth/hasManagerRole'
    })
  }
}
</script>
